import React from 'react';
import GoogleLoginButton from './googleLogin';
import KakaoLoginButton from './kakaoLogin';
import NaverLoginButton from './naverLogin';
import LoginForm from './facebookLogin';
import LogoComponent from './LogoComponent';
import ImageComponent from './ImageComponent';

import './LoginButtons.css';

const LoginButtons = () => {
    return (
        <div class="parent-container">
            <LogoComponent></LogoComponent>
            <ImageComponent src="https://taki-bucket-1-1-0.s3.ap-northeast-2.amazonaws.com/message.png" alt='img'></ImageComponent>
            <div className="login-buttons-container">

                <GoogleLoginButton />
                <KakaoLoginButton />
                <NaverLoginButton />
                <LoginForm />

            </div>
        </div>
    );
};

export default LoginButtons;
